var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import trottle from 'lodash.throttle';
import { useEffect, useRef, useState } from 'react';
import { Tooltip } from '@snack-uikit/tooltip';
import { extractSupportProps } from '@snack-uikit/utils';
import { isEllipsisActive, truncateStringMiddle } from '../../helpers';
import styles from './styles.module.css';
export function TruncateStringMiddle(_a) {
    var { text, className, hideTooltip, placement } = _a, rest = __rest(_a, ["text", "className", "hideTooltip", "placement"]);
    const [showTooltip, setShowTooltip] = useState(false);
    const [truncatedString, setTruncatedString] = useState(text);
    const textElementRef = useRef(null);
    const truncatedTextElementRef = useRef(null);
    useEffect(() => {
        const setTruncate = trottle(() => {
            setTruncatedString(truncateStringMiddle({
                element: textElementRef.current,
                truncatedElement: truncatedTextElementRef.current,
                text,
            }));
            setShowTooltip(isEllipsisActive(textElementRef.current));
        }, 50);
        setTruncate();
        const observer = new ResizeObserver(setTruncate);
        if (textElementRef.current) {
            observer.observe(textElementRef.current);
        }
        return () => {
            observer.disconnect();
        };
    }, [showTooltip, text, hideTooltip]);
    const textElement = (_jsxs(_Fragment, { children: [_jsx("span", { ref: textElementRef, className: styles.fullText, "data-test-id": 'full-text', children: text }), _jsx("span", { ref: truncatedTextElementRef, className: styles.truncatedText, "data-test-id": 'truncated-text', children: truncatedString })] }));
    return (_jsx("span", Object.assign({ className: cn(styles.wrapper, className) }, extractSupportProps(rest), { children: showTooltip && !hideTooltip ? (_jsx(Tooltip, { tip: text, placement: placement, hoverDelayOpen: 500, triggerClassName: styles.textContainer, children: textElement })) : (textElement) })));
}
